<template>
  <div class="__MyAccount">
    <CSection separate>
      <CTitle large margin-bottom>
        {{ $t('My account') }}
      </CTitle>

      <Row gutter="md" class="mb-lg">
        <Col col="12" md="6">
          <LabelValue :label="$t('Username')" :value="username" />
        </Col>

        <Col col="12" md="6">
          <LabelValue :label="$t('Wave ID')" :value="userId" />
        </Col>

        <Col col="12" md="6">
          <LabelValue :label="$t('Group Name')" :value="groupName" />
        </Col>

        <Col col="12" md="6">
          <LabelValue :label="$t('Group ID')" :value="groupId" />
        </Col>

        <Col col="12" md="6">
          <LabelValue :label="$t('Email')" :value="email" />
        </Col>
      </Row>
    </CSection>

    <CSection separate v-if="$can('ModifySettings')">
      <CTitle large margin-bottom>
        {{ $t('Password and Authentication') }}
      </CTitle>

      <MyAccountPassword />
      <MyAccountMfa v-if="!isSSO" />
    </CSection>

    <CSection>
      <CTitle large margin-bottom>
        {{ $t('Language') }}
      </CTitle>

      <MyAccountLanguage />
    </CSection>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import PairValues from '@design-system/components/PairValues.vue';
import LabelValue from '@design-system/components/LabelValue.vue';
import Input from '@design-system/components/Input.vue';
import Icon from '@design-system/components/Icon.vue';
import Row from '@design-system/components/Row.vue';
import Col from '@design-system/components/Col.vue';
import Button from '@design-system/components/Button.vue';
import Form from '@design-system/components/Form.vue';

import CSection from '@/components/uikit/CSection';
import CTitle from '@/components/uikit/CTitle';

import MyAccountPassword from '@/pages/Preferences/MyAccountPassword';
import MyAccountMfa from '@/pages/Preferences/MyAccountMfa';
import MyAccountLanguage from '@/pages/Preferences/MyAccountLanguage';

const messages = {
  en: {
    'My account': 'My Account',
    Username: 'Username',
    'Wave ID': 'Wave ID',
    'Group ID': 'Group ID',
    'Group Name': 'Group Name',
    Email: 'Email',
    'Password and Authentication': 'Password and Authentication',
    Language: 'Language',
  },
  ja: {
    'My account': 'マイアカウント',
    Username: 'ユーザー名',
    'Wave ID': 'Wave ID',
    'Group ID': 'グループID',
    'Group Name': 'グループ名',
    Email: 'メールアドレス',
    'Password and Authentication': 'パスワードと認証',
    Language: '言語 (Language)',
  },
};

export default {
  name: 'MyAccount',
  i18n: { messages },
  components: {
    PairValues,
    LabelValue,
    Input,
    Icon,
    Row,
    Col,
    Button,
    Form,
    CSection,
    CTitle,
    MyAccountPassword,
    MyAccountMfa,
    MyAccountLanguage,
  },
  watch: {
    currentPassword(value) {
      this.currentPassword = value.replace(/\s+/g, '');
    },
    newPassword(value) {
      this.newPassword = value.replace(/\s+/g, '');
    },
  },
  computed: {
    ...mapGetters('user', {
      isSSO: 'isSSO',
      isAccessGroup: 'isAccessGroup',
      username: 'getUserName',
      userId: 'getUserId',
      groupName: 'getBillingGroupName',
      groupId: 'getBillingGroupId',
      email: 'getUserEmail',
    }),
  },
};
</script>
